import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmsRoutingModule } from './sms-routing.module';
import { AdminModule } from '../admin/admin.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { SmsSettingComponent } from './sms-setting/sms-setting.component';
import { TemplateComponent } from './template/template.component';
import { GroupComponent } from './group/group.component';
import { ContactComponent } from './contact/contact.component';
import { FeeDueAlertComponent } from './fee-due-alert/fee-due-alert.component';
import { EmergencyMessageComponent } from './emergency-message/emergency-message.component';
import { MarksAlertComponent } from './marks-alert/marks-alert.component';
import { BirthdayAlertComponent } from './birthday-alert/birthday-alert.component';
import { SmsBalanceComponent } from './sms-balance/sms-balance.component';
import { FeeDueAlertPrintComponent } from './fee-due-alert-print/fee-due-alert-print.component';


@NgModule({
  declarations: [SmsSettingComponent, TemplateComponent,GroupComponent, ContactComponent,FeeDueAlertComponent,
    EmergencyMessageComponent, MarksAlertComponent,BirthdayAlertComponent,  SmsBalanceComponent, FeeDueAlertPrintComponent],
    
    imports: [
    CommonModule,
    SmsRoutingModule,    
    AdminModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot()
   
   
  ]
})
export class SmsModule { }
